import { c as _c } from "react/compiler-runtime";
import React, { useState } from 'react';
import { InstantSearch, Configure, Index } from 'react-instantsearch';
import PropTypes from 'prop-types';
import { noEmptySearchClient } from 'components/essentials/AlgoliaSearchClient';
import { ALGOLIA_INDEX_NAME } from 'commons/constants';
import classNames from 'classnames';
import useToggleIsSearchOpen from 'global-state/isSearchOpen/useToggleIsSearchOpen';
import useAllOptions from 'data-hooks/useAllOptions';
import JBSearchBox from 'components/consumer/consumer-search/components/JBSearchBox';
import { SearchResults, CategoryHits, StaticPageHits, ResultsByCategory, ProductResultsMobile } from '../../commons/helpers';
const InstantSearchMobileLegacy = t0 => {
  const $ = _c(43);
  const {
    autoFocus: t1,
    placeholder: t2,
    setSearchEventParams,
    toggleMenu,
    variant: t3,
    toggleMobileSearchBar
  } = t0;
  const autoFocus = t1 === undefined ? true : t1;
  const placeholder = t2 === undefined ? "What can we help you find?" : t2;
  const variant = t3 === undefined ? "default" : t3;
  const [lastQuery, setLastQuery] = useState("");
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = [];
    $[0] = t4;
  } else {
    t4 = $[0];
  }
  const [lastQueryTopThreeRes, setLastQueryTopThreeRes] = useState(t4);
  const [inactive, setInactive] = useState(false);
  const toggleIsSearchOpen = useToggleIsSearchOpen();
  const allOptionsData = useAllOptions();
  let t5;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Configure hitsPerPage={3} facets={["type", "option_name"]} numericFilters={["item_availability<2", "visibility>0", "visibility<4"]} />;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  let t6;
  if ($[2] !== autoFocus || $[3] !== placeholder || $[4] !== setSearchEventParams || $[5] !== toggleIsSearchOpen || $[6] !== toggleMenu || $[7] !== toggleMobileSearchBar) {
    t6 = <JBSearchBox autoFocus={autoFocus} inMobileNav={true} isActive={autoFocus} placeholder={placeholder} setSearchEventParams={setSearchEventParams} toggleMenu={toggleMenu} toggleSearchOpen={toggleIsSearchOpen} variant="InstantSearchMobile" toggleMobileSearchBar={toggleMobileSearchBar} />;
    $[2] = autoFocus;
    $[3] = placeholder;
    $[4] = setSearchEventParams;
    $[5] = toggleIsSearchOpen;
    $[6] = toggleMenu;
    $[7] = toggleMobileSearchBar;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const t7 = variant === "consumer-header-mobile";
  let t8;
  if ($[9] !== t7) {
    t8 = classNames({
      "bg-white relative z-[1000] pb-36 max-h-[calc(100dvh-7.5rem)] overflow-y-auto overflow-x-hidden": t7
    });
    $[9] = t7;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== allOptionsData || $[12] !== inactive || $[13] !== lastQuery || $[14] !== lastQueryTopThreeRes || $[15] !== toggleMenu || $[16] !== toggleMobileSearchBar) {
    t9 = <ProductResultsMobile isInstantSearch={true} layout="minimal" lastQuery={lastQuery} setLastQuery={setLastQuery} inactive={inactive} setInactive={setInactive} lastQueryTopThreeRes={lastQueryTopThreeRes} setLastQueryTopThreeRes={setLastQueryTopThreeRes} toggleSearchOpen={toggleMobileSearchBar} toggleMenu={toggleMenu} allOptionsData={allOptionsData} />;
    $[11] = allOptionsData;
    $[12] = inactive;
    $[13] = lastQuery;
    $[14] = lastQueryTopThreeRes;
    $[15] = toggleMenu;
    $[16] = toggleMobileSearchBar;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <Configure hitsPerPage={5} numericFilters={["fk_store_id=1"]} facetFilters={["is_searchable:1"]} attributesToRetrieve={["objectID", "category_name", "category_sef_url", "url"]} />;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== toggleMobileSearchBar) {
    t11 = <Index indexName="categories">{t10}<CategoryHits toggleSearchOpen={toggleMobileSearchBar} variant="mobile" /></Index>;
    $[19] = toggleMobileSearchBar;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <Configure hitsPerPage={3} numericFilters={["is_active=1", "show_in_search=1", "fk_store_id=1"]} />;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== toggleMobileSearchBar) {
    t13 = <Index indexName="static_pages_new">{t12}<StaticPageHits toggleSearchOpen={toggleMobileSearchBar} variant="mobile" /></Index>;
    $[22] = toggleMobileSearchBar;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== toggleMobileSearchBar) {
    t14 = <div className="[border-right:1px_solid_#f1f1f1] pt-5 pr-8 pb-10 p-0 min-h-[auto] mb-2 w-full border-0 order-[-1]"><ResultsByCategory toggleSearchOpen={toggleMobileSearchBar} variant="mobile" /></div>;
    $[24] = toggleMobileSearchBar;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  let t15;
  if ($[26] !== t13 || $[27] !== t14) {
    t15 = <div className="min-w-[20%] flex-[0_1_20%] h-full p-0 instant-search-form__each-results-container-non-padded">{t13}{t14}</div>;
    $[26] = t13;
    $[27] = t14;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  let t16;
  if ($[29] !== t11 || $[30] !== t15 || $[31] !== t9) {
    t16 = <div className="text-[.8em] flex w-full mx-[3.333vw] my-0 text-sm flex-col m-0 font-bold">{t9}{t11}{t15}</div>;
    $[29] = t11;
    $[30] = t15;
    $[31] = t9;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] !== t16 || $[34] !== t8) {
    t17 = <div className={t8}>{t16}</div>;
    $[33] = t16;
    $[34] = t8;
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  let t18;
  if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <Index indexName="reviews"><Configure facets={["*"]} numericFilters="" facetFilters="" /></Index>;
    $[36] = t18;
  } else {
    t18 = $[36];
  }
  let t19;
  if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <Index indexName="customer_photos"><Configure facets={["*"]} numericFilters="" /></Index>;
    $[37] = t19;
  } else {
    t19 = $[37];
  }
  let t20;
  if ($[38] !== t17) {
    t20 = <SearchResults>{t17}{t18}{t19}</SearchResults>;
    $[38] = t17;
    $[39] = t20;
  } else {
    t20 = $[39];
  }
  let t21;
  if ($[40] !== t20 || $[41] !== t6) {
    t21 = <InstantSearch searchClient={noEmptySearchClient} indexName={ALGOLIA_INDEX_NAME.PRODUCTS}>{t5}{t6}{t20}</InstantSearch>;
    $[40] = t20;
    $[41] = t6;
    $[42] = t21;
  } else {
    t21 = $[42];
  }
  return t21;
};
InstantSearchMobileLegacy.propTypes = {
  autoFocus: PropTypes.bool,
  placeholder: PropTypes.string,
  setSearchEventParams: PropTypes.func,
  toggleMenu: PropTypes.func,
  variant: PropTypes.string,
  toggleMobileSearchBar: PropTypes.func
};
export default InstantSearchMobileLegacy;